import React, { useEffect, useState } from "react";
import axios from "axios";
import TemplateComp from "./templateComp";
import Header from "./Header";
import LinkExpire from "./linkExpire";
function ContentReaderMarkdown() {
   const [content, setContent] = useState("");
   const [error, setError] = useState(false);
   const encodedUrl = window.location.href;
   let urlNew = encodedUrl.split("url")[1];
   urlNew = urlNew.substring(1);
   urlNew = urlNew.replace(/-/g, "+").replace(/_/g, "/");
   let originalString = atob(urlNew);

   useEffect(() => {
      const fetchData = async (urlToFetch) => {
         try {
            const response = await axios.get(urlToFetch);
            if (response?.data?.new) {
               setContent(response.data?.new);
            } else {
               setContent(response.data);
            }
         } catch (error) {
            setError(true);
            console.error(`Error: ${{ error }}`);
         }
      };
      if (originalString) {
         fetchData(originalString);
      }
   }, [originalString]);

   return (
      <div className="py-2">
         <Header />
         {content && <TemplateComp content={content} />}
         {error && (
            <div className="link-expire-cont">
               <LinkExpire />
            </div>
         )}
      </div>
   );
}

export default ContentReaderMarkdown;
